import { useOktaAuth } from '@okta/okta-react';
import { normalizeInternalEmail } from '../shared/utils/utils';

// Single source for the signed-in reviewer's email. Reads the raw Okta claim and
// normalizes a legacy @tbkbank.com identity to the canonical @tfin.com so client-side
// comparisons and telemetry match the backend/DB, which store the normalized form (ORIG-742).
export const useCurrentUserEmail = (): string | undefined => {
    const { authState } = useOktaAuth() ?? {};
    const rawEmail = authState?.idToken?.claims?.email as string | undefined;

    return rawEmail ? normalizeInternalEmail(rawEmail) : rawEmail;
};
